module.exports = __webpack_public_path__ + "assets/img/22_392_big.64a56ffa.jpg";